<script lang="ts">
  import GSAP from 'gsap';
  import {store} from '../../store/store';
  import {IconType} from '../../utils/icons/types/IconType';
  import {portraitNames} from '../../utils/metaData';
  import type { PointerLockControls } from 'three/examples/jsm/controls/PointerLockControls';
  import Icon from '../Icon/Icon.svelte';

  let creativeIndex: number = 0;
  let shouldRenderLink: boolean = false;
  let metaContainer: HTMLElement;
  let currentSession: boolean;
  let isMobile: boolean;

  store.isMobileDevice.subscribe(value => {
    isMobile = value;
  });

  const handleEvent = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      if (portraitNames[creativeIndex].instagram) {
        window.open(portraitNames[creativeIndex].instagram, '__blank');
      }

      if (portraitNames[creativeIndex].url) {
        window.open(portraitNames[creativeIndex].url, '__blank');
      }
    }
  };

  store.creativeIndex.subscribe(index => {
    if (metaContainer) {
      if (typeof index === 'number') {
        creativeIndex = index;
        console.log('open');

        GSAP.to(metaContainer, {duration: 0.5, opacity: 1});
        metaContainer.style.display = 'flex';

        if (portraitNames[index].instagram) {
          window.addEventListener('keydown', handleEvent, true);
        }

        if (portraitNames[index].url) {
          window.addEventListener('keydown', handleEvent, true);
        }
      } else {
        window.removeEventListener('keydown', handleEvent, true);
        GSAP.to(metaContainer, {duration: 0.5, opacity: 0});
        console.log('close');

        setTimeout(() => {
          metaContainer.style.display = 'none';
        }, 500);
      }
    }
  });

  store.currentSession.subscribe(v => {
    currentSession = v;
  });
</script>

{#if currentSession}
	<section bind:this={metaContainer}>
		<div class="container">
			<!-- Art name -->
			<h3>{portraitNames[creativeIndex].name}</h3>

			<!-- Artist name -->
			{#if portraitNames[creativeIndex].instagram}
				<p>Dibuat oleh {portraitNames[creativeIndex].artist}</p>
			{/if}

			<!-- Description of Art -->
			{#if portraitNames[creativeIndex].artDescription}
				<p>{@html portraitNames[creativeIndex].artDescription}</p>
			{/if}

			<!-- Artist Description -->
			<p>{@html portraitNames[creativeIndex].description}</p>

			<!-- URL Instagram -->
			{#if portraitNames[creativeIndex].instagram}
				<div class="link-container">
					<a href={portraitNames[creativeIndex].instagram} target="__blank" class="instagram-icon">
						<Icon icon={IconType.instagram}/>
					</a>
					{#if !isMobile}
						<p>Press enter to visit Instagram</p>
					{:else}
						<a href={portraitNames[creativeIndex].instagram} target="__blank" style="text-decoration: none; color: #FFF;">Tap here to visit Instagram</a>
					{/if}

				</div>
			{/if}

			<!-- URL Gamification -->
			{#if portraitNames[creativeIndex].url}
				<div class="link-container">
					<a href={portraitNames[creativeIndex].url} target="__blank" class="instagram-icon">
						<svg xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF" viewBox="0 0 512 512">
							<path
								d="M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 21 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"/>
						</svg>
					</a>
					{#if !isMobile}
						<p>Press enter to visit</p>
					{:else}
						<a href={portraitNames[creativeIndex].url} target="__blank" style="text-decoration: none; color: #FFF;">Tap here to visit</a>
					{/if}
				</div>
			{/if}

			<!-- Hashtag -->
			<p>Grab, Collect and Scan Now! #20Soccereditionpacks #DjarumSuper #IniRasanyaSuper #Collaboration</p>
		</div>
	</section>
{/if}

<style type="text/scss">
  @import '../../styles/styles.scss';

  section {
    position: fixed;
		overflow-y: auto;
    top: 0;
    right: 0;
    width: 100%;
    height: 400px;
    z-index: 10;
    padding: 40px 25px;
    background-color: rgba(193, 2, 31, 0.5);
    background: linear-gradient(
                    360deg,
                    rgba(102, 102, 102, 0) 0%,
                    rgba(193, 2, 31, 0.5) 35%,
                    rgba(193, 2, 31, 0.7) 100%
    );
    display: none;
    opacity: 0;
    justify-content: space-evenly;

    .container {
      max-width: 600px;
      width: 100%;
      color: #fff;

      h3 {
        font-family: $font-title-italic;
        font-size: 1.75rem;
      }

      p {
        font-size: 1rem;
        font-family: $font-title-regular;
      }

      .link-container {
        font-family: $font-title-regular;
        display: flex;
        align-items: center;
        width: max-content;
        font-size: 0.75rem;

        .instagram-icon {
          margin-right: 10px;
          width: 23px;
          color: #fff;
        }
      }
    }
  }

  @media screen and (min-width: 1028px) {
    section {
      width: 50%;
      height: 100%;
      padding: 25px;

      background: linear-gradient(
                      90deg,
                      rgba(193, 2, 31, 0.1) 0%,
                      rgba(193, 2, 31, 0.6) 50%,
                      rgba(193, 2, 31, 0.9) 100%
      );
    }
  }

  @media screen and (min-width: 1450px) {
    section {
      padding: 25px;
      display: none;
      opacity: 0;
      justify-content: space-evenly;

      .container {
        max-width: 100%;
        width: 100%;
        color: #fff;

        h3 {
          font-size: 2.75rem;
        }

        p {
          font-size: 1.25rem;
        }

        .link-container {
          display: flex;
          align-items: center;
          width: max-content;
          font-size: 1rem;

          .instagram-icon {
            margin-right: 10px;
            width: 30px;
            color: #fff;
          }
        }
      }
    }
  }
</style>
